import MaterialTable, { MTableBodyRow } from '@material-table/core'
import { Chip, Link } from '@material-ui/core'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import { getChipStyles } from '../../services/helpers'
import { tableAlternateDark } from '../../services/theme'
import moment from 'moment-timezone'
import useSelectedFacility from '../../hooks/useSelectedFacility'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	chipRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	addOnRow: {
		'&:hover': {
			'& .addOnButton': {
				opacity: 0.6,
				transition: 'opacity 250ms ease-in-out'
			}
		},
		'& .addOnButton': {
			color: '#777679',
			size: '12px',
			opacity: 0,
			transition: 'opacity 250ms ease-in-out'
		}
	}
}))

// const MED_DETAILS = [
// 	['Active', (med) => (med?.active ? 'Yes' : 'No')],
// 	['Prescription', (med) => (med?.prescription ? 'Yes' : 'No')],
// 	['Frequency', (med) => med?.frequency],
// 	[
// 		'Times of Day',
// 		(med) =>
// 			med?.times_of_day.map((time) => {
// 				return <StyledChip label={time} />
// 			})
// 	],
// 	['Dosage', (med) => med?.dosage],
// 	['Purpose', (med) => med?.purpose],
// 	['Instructions', (med) => med?.instructions],
// 	['Team Notes', (med) => med?.team_notes]
// ]

const MedicationsTable = ({ medications, visit, pet }) => {
	const classes = useStyles()
	const { facility, allStaff } = useSelectedFacility()
	const [meds, setMeds] = useState([])

	const timeZone = facility?.time_zone || 'America/New_York'

	const household_id = visit?.household_id
	const pet_id = pet?._id

	useEffect(() => {
		if (medications) {
			try {
				setMeds(medications || [])
			} catch (e) {
				console.log('bad error', e)
			}
		}
	}, [medications])

	const renderStatus = (med) => {
		let status = med.completed ? 'Completed' : 'Upcoming'

		if (med.status) status = med.status

		return (
			<div className={classes.chipRow}>
				<Chip label={status ? status : 'No Status'} style={status ? getChipStyles(status) : null} />
			</div>
		)
	}

	const renderName = (med) => {
		const link = `/clients/${household_id}/pets/${pet_id}`

		return (
			<Link component={RouterLink} to={link}>
				{med.name || 'Medication'}
			</Link>
		)
	}

	const renderStaffName = (med) => {
		const { staff_id, completed } = med

		if (!staff_id && !completed) {
			return 'Pending'
		}

		if (!staff_id) {
			return 'Unknown'
		}

		const staff = allStaff.find((st) => st._id === staff_id)
		return staff ? `${staff.first_name} ${staff.last_name?.charAt(0)}` : 'Unknown'
	}

	return (
		<div>
			<MuiThemeProvider theme={tableAlternateDark}>
				<MaterialTable
					style={{
						boxShadow: 'none',
						borderRadius: '0px'
					}}
					options={{
						headerStyle: {
							color: '#1A1A35',
							textTransform: 'uppercase',
							fontWeight: 800,
							fontSize: '12px',
							lineHeight: '16px',
							padding: '11px 24px',
							backgroundColor: '#F9F9F9'
						},
						actionsColumnIndex: -1,
						toolbarButtonAlignment: 'left',
						searchFieldAlignment: 'left',
						paging: false,
						toolbar: false
					}}
					localization={{
						header: {
							actions: ''
						}
					}}
					columns={[
						{
							title: 'Medication',
							render: (data) => renderName(data),
							cellStyle: { textTransform: 'capitalize' }
						},
						{
							title: 'Dosage',
							render: (data) => <span>{data.dosage}</span>
						},
						{
							title: 'Time',
							render: (data) => (
								<span>{moment(data.time_delivered).tz(timeZone).format('hh:mma')}</span>
							)
						},
						{ title: 'Staff', width: '100px', render: (data) => <span>{renderStaffName(data)}</span> },
						{ title: 'Status', render: (data) => renderStatus(data) }
					]}
					data={meds}
					components={{
						Row: (props) => <MTableBodyRow className={classes.addOnRow} {...props} />
					}}
				/>
			</MuiThemeProvider>
			{/* <StyledDialog
				width={500}
				maxWidth={500}
				minWidth={500}
				minHeight={300}
				open={isShown}
				title={`${selectedMed?.name} Details`}
				onClose={() => setIsShown(false)}>
				<table style={{ margin: '0 1.5rem', overflow: 'scroll' }}>
					{MED_DETAILS.map(([title, render], i) => {
						const even = i % 2 === 0
						return (
							<tr style={{ backgroundColor: even ? '#f2f2f2' : 'white' }}>
								<td style={{ padding: '8px' }}>{title}</td>
								<td style={{ padding: '8px' }}>{render(selectedMed)}</td>
							</tr>
						)
					})}
				</table>
			</StyledDialog> */}
		</div>
	)
}

export default MedicationsTable
